import { TransferMethodEnum, TransferStatusEnum  } from "@gtpl/shared-models/common-models";
import { PackingStockTransferData } from "../dto/packing-stock-transfer.model";
import { TransferItems } from "../entities/transfer-items.entity";
import { TransferInfo } from "../entities/transfer-material.entity";

export class TransferMaterialAdapter{
    convertDtoToEntity(createData: PackingStockTransferData):TransferInfo{
        console.log("createData Adaptor")
        console.log(createData)

        try{
            const transferEntity = new TransferInfo();
            transferEntity.isPreparedMaterial = createData.isPreparedMaterial;
            if(createData.packingStockTransferId){
                transferEntity.packingStockTransferId = createData.packingStockTransferId;
                transferEntity.updatedUser = createData.updatedUser;
            }else{
                transferEntity.createdUser = createData.createdUser;
                transferEntity.status = TransferStatusEnum.IN_TRANSIT;
            }
            transferEntity.transferType = createData.transferType;
            transferEntity.transferMethod = createData.transferMethod;
            if(createData.transferMethod == TransferMethodEnum["Plant To Third Party"]){
                transferEntity.toPlant = 0;
                transferEntity.status = TransferStatusEnum.RECEIVED;

            }
            transferEntity.fromPlant = createData.fromPlant;
            if(createData.transferMethod === TransferMethodEnum["Plant To Plant"]){
                console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&*********")
                transferEntity.toPlant = createData.toPlant;
            }
            if(createData.transferMethod === TransferMethodEnum["Warehouse To Plant"]){
                transferEntity.toPlant = createData.toPlant;
                transferEntity.indentId = createData.indentId;
            }
            transferEntity.unitId = createData.fromPlant;
            transferEntity.transferredDate = createData.transferredDate;
            transferEntity.dcNumber = createData.dcNumber;
            transferEntity.note = createData.note;
            if(createData.saleOrderId){
                transferEntity.saleOrderId = createData.saleOrderId;
                transferEntity.saleOrderItemId = createData.saleOrderItemId;
            }
    
            const ItemsEntity : TransferItems[]=[];
            for (const item of createData.stockTransferItems) {
                console.log("***************************************************************");
                console.log(item);
                const itemEntity = new TransferItems();
                itemEntity.itemCategoryId = item.itemCategoryId;
                itemEntity.itemSubCategoryId = item.itemSubCategoryId;
                itemEntity.itemId = item.itemId;
                if(item.saleOrderId){
                    itemEntity.saleOrderId = item.saleOrderId;
                }
                // itemEntity.sizeId = item.sizeId;
                // if(createData.transferMethod == TransferMethodEnum.INDENT)
                // {
                    itemEntity.transferredQty = item.issuedQty;
                // }
                // else{
                //     itemEntity.transferredQty = item.requiredQty;
                // }
                itemEntity.unitPrice = item.unitPrice;
                itemEntity.stockIds = item.stockIds;
                ItemsEntity.push(itemEntity);
            }
            transferEntity.stockTransferItems=ItemsEntity;
            
            return transferEntity;
        }catch(error){
            console.log("error");
            console.log(error);
            return error;
        }
        
    }
    // public convertEntityToDto(obj: any, createdData:PackingStockTransferData): PackingStockTransferData {

    //     const packingStockTransferData= new PackingStockTransferData;
    //     packingStockTransferData.createdUser = obj.createdUser;
    //     packingStockTransferData.dcNumber = obj.dcNumber;
    //     packingStockTransferData.fromPlant = obj.fromPlant;
    //     packingStockTransferData.mrnNumber = obj.mrnNumber;
    //     packingStockTransferData.indentId = obj.indentId;
    //     packingStockTransferData.note = obj.note;
    //     packingStockTransferData.packingStockTransferId = obj.packingStockTransferId;
    //     packingStockTransferData.saleOrderId = obj.saleOrderId;
    //     packingStockTransferData.toPlant = obj.toPlant;
    //     packingStockTransferData.transferMethod = obj.transferMethod;
    //     packingStockTransferData.transferType = obj.transferType;
    //     packingStockTransferData.transferredDate = obj.transferredDate;
    //     packingStockTransferData.updatedUser = obj.updatedUser;
    //     packingStockTransferData.stockTransferItems = createdData.stockTransferItems;


    //     return packingStockTransferData;
    //   }
}